
import Swiper from 'swiper';
import {Autoplay, EffectCoverflow, Navigation, Pagination} from 'swiper/modules';
import {limitSwiperPagination, resolveSliderLayout} from '../../../../eila-global/js/slider/sliderHelpers.js';

export function initHistorySlider(query = document.querySelectorAll('.historyEilaSlider')) {
    for (let slider of query) {
        let options = {
            autoplay_interval: 5000,
            eff_interval: 300,
        }

        Swiper.use([Autoplay, Navigation, Pagination]);
        const swiper = new Swiper(slider, resolveSliderLayout(slider, {
            loop: true,
            speed: options.eff_interval,
            centeredSlides: true,
            slidesPerView: 1,
            autoplay: {
                delay: options.autoplay_interval,
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                addIcons: false,
            },
            pagination: {
                el: slider.querySelector('.swiper-pagination')
            }
        }));

        limitSwiperPagination(swiper);
    }
}
